import { api, authHeader } from "../configs/axiosConfigs";

const SupplierPackagesApiService = {
  // دریافت لیست پکیج‌های تامین‌کننده
  getSupplierPackages: async (params) => {
    const response = await api.request({
      url: "/SLN/Supplier/PackageManagement/GetList",
      method: "GET",
      params: params,
      headers: authHeader(),
    });
    return response.data;
  },

  // دریافت جزئیات پکیج برای ویرایش
  getPackageById: async (id) => {
    const response = await api.request({
      url: `/SLN/Supplier/PackageManagement/GetById?id=${id}`,
      method: "GET",
      headers: authHeader(),
    });
    return response.data;
  },

  // ایجاد یا ویرایش پکیج
  modifyPackage: async (packageData) => {
    const response = await api.request({
      url: "/SLN/Supplier/PackageManagement/Modify",
      method: "POST",
      headers: authHeader(),
      data: packageData,
    });
    return response.data;
  },

  // حذف پکیج
  deletePackage: async (id) => {
    const response = await api.request({
      url: `/SLN/Supplier/PackageManagement/Delete/${id}`,
      method: "DELETE",
      headers: authHeader(),
    });
    return response.data;
  },

  // دریافت گزینه‌های ظرفیت نیروگاه
  getPlantCapacityOptions: async () => {
    const response = await api.request({
      url: "/SLN/Supplier/PackageManagement/PlantCapacityOptions",
      method: "GET",
      headers: authHeader(),
    });
    return response.data;
  },

  // دریافت انواع تجهیزات
  getEquipmentTypes: async () => {
    const response = await api.request({
      url: "/SLN/Supplier/PackageManagement/EquipmentTypes",
      method: "GET",
      headers: authHeader(),
    });
    return response.data;
  },

  // دریافت وضعیت‌های پکیج
  getPackageStatuses: async () => {
    const response = await api.request({
      url: "/SLN/Supplier/PackageManagement/PackageStatuses",
      method: "GET",
      headers: authHeader(),
    });
    return response.data;
  },
};

export default SupplierPackagesApiService;
